<template>
  <div class="container">
    <el-row type="flex" justify="center">
      <el-col :xs="18" :sm="18" :md="19" :lg="14" :xl="12" class="center">
        <el-row type="flex" class="row-bg" justify="center">
          <el-col :span="9">
            <div
              style="text-align:center;height:300px;width:95%;display: flex;align-items: center;justify-content: center;">
              <img :src="imgUrl">
            </div>
          </el-col>
          <el-col :span="9">
            <h2 style="text-align:center;color:#09273e;margin-bottom: 50px">登录管理系统</h2>
            <el-form :model="loginForm" status-icon :rules="rules" ref="loginForm" label-width="50px"
              class="demo-ruleForm">
              <el-form-item prop="name">
                <el-input type="text" placeholder="用户名" v-model="loginForm.name" auto-complete="off" clearable
                  oninput="this.value=this.value.replace(/[, ]/g,'')" @keyup.enter.native="submitLoginForm('loginForm')"></el-input>
              </el-form-item>
              <el-form-item prop="pass">
                <el-input type="password" placeholder="密码" v-model="loginForm.pass" auto-complete="off" clearable
                  oninput="this.value=this.value.replace(/[, ]/g,'')" @keyup.enter.native="submitLoginForm('loginForm')"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="text" size="small" @click="forget()" style="float: right">忘记密码？
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitLoginForm('loginForm')" style="width:100%">登录
                </el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { login } from '@/api/Login';

export default {
  data() {
    // var tel=/^1[345678]\d{9}$/;
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback('请输入用户名');
      } else {
        if (this.loginForm.name !== '') {
        }
        callback();
      }
      // } else if(tel.test(value)){
      //    callback();
      // } else {
      //   if (this.loginForm.pass !== '') {
      //     this.$refs.loginForm.validateField('pass');
      //   }
      //   callback(new Error('请输入正确的手机号'));
      // }
    };
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback('请输入密码');
      } else {
        if (this.loginForm.pass !== '') {
        }
        callback();
      }
    };
    const validateCheck = (rule, value, callback) => {
      if (value === '') {
        callback('请输入验证码');
      } else {
        if (this.loginForm.check !== '') {
        }
        callback();
      }
    };
    return {
      loginForm: {
        name: '',
        pass: '',
        check: '',
      },
      rules: {
        name: [
          { validator: validateName, trigger: 'blur' },
        ],
        pass: [
          { validator: validatePass, trigger: 'blur' },
        ],
        check: [
          { validator: validateCheck, trigger: 'blur' },
        ],
      },
      imgUrl: '',
    };
  },
  methods: {
    // 忘记密码
    forget() {
      this.$router.push({ name: 'forget' });
    },
    // 登录
    submitLoginForm(formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const data = {
                ACCOUNT: this.loginForm.name,
                PASSWORD: this.loginForm.pass,
              };
              login(data).then((res) => {
                if (res[0]) {
                  sessionStorage.setItem('userId', res[0].USER_ID);
                  sessionStorage.setItem('session', res[0].SESSION);
                  sessionStorage.setItem('name', res[0].NAME);
                  sessionStorage.setItem('companyId', res[0].COMPANY_ID);
                  sessionStorage.setItem('userId', res[0].USER_ID);
                  sessionStorage.setItem('session', res[0].SESSION);
                  sessionStorage.setItem('name', res[0].NAME);
                  sessionStorage.setItem('companyId', res[0].COMPANY_ID);
                  if (res[0].IS_FIRST == 1) {
                    this.$router.push({ path: '/loginEditPass' });
                    document.body.style.cursor = 'default';
                  } else {
                    this.$router.push({ path: '/formalUserManage' });
                    document.body.style.cursor = 'default';
                  }
                } else {
                  document.body.style.cursor = 'default';
                }
              }).catch((err) => {
                this.$message.show({ text: err, type: 'error' });
                document.body.style.cursor = 'default';
              });
            } else {
              document.body.style.cursor = 'default';
            }
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    const baseRightUrl = window.location.href;
    const rightData = baseRightUrl.split('/');
    // console.log(rightData[3])
    next((vm) => {
      if (rightData[3] === 'tc_admin') {
        // vm.imgUrl = 'https://service.linkda.com.cn/file/tcpics/mjd/icon.png';
        vm.imgUrl = 'https://service.linkda.com.cn/file/tcpics/lkd/icon.png';
        // vm.imgUrl = 'https://service1.mckintey.top/file/tcpics/mjd/icon.png'
        // vm.imgUrl = 'https://service1.mckintey.top/file/tcpics/yunpeng/icon.png'
        // vm.imgUrl = 'https://service.linkda.com.cn/file/tcpics/yunpeng/icon.png'
        // vm.imgUrl = 'https://service.linkda.com.cn/file/tcpics/Newcapec/icon.jpg';
      } else if (rightData[3] === '#') {
        // vm.imgUrl = 'https://service.linkda.com.cn/file/tcpics/mjd/icon.png';
        vm.imgUrl = 'https://service.linkda.com.cn/file/tcpics/lkd/icon.png';
        // vm.imgUrl = 'https://service1.mckintey.top/file/tcpics/mjd/icon.png';
        // vm.imgUrl = 'https://service1.mckintey.top/file/tcpics/yunpeng/icon.png'
        // vm.imgUrl = 'https://service.linkda.com.cn/file/tcpics/yunpeng/icon.png'
        // vm.imgUrl = 'https://service.linkda.com.cn/file/tcpics/Newcapec/icon.jpg';
      } else {
        vm.imgUrl = `https://service.linkda.com.cn/file/tcpics/${rightData[3]}/icon.png`;
        // vm.imgUrl = 'https://service1.mckintey.top/file/tcpics/'+ rightData[3]+ '/icon.png'
      }
    });
  },
};
</script>
<style>
.container {
  position: absolute;
  width: 100%;
  height: 100%;
  background: url('../assets/images/background1.jpg') no-repeat center center !important;
  /* background: url('../assets/images/background.png') no-repeat center center !important; */
  background-size: 100% 100% !important;
  -moz-background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
  z-index: 10;
}

.center {
  margin-top: 10%;
  padding-top: 50px;
  padding-bottom: 50px;
  background: url('../assets/images/center.png') no-repeat center center;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
}

.el-form {
  margin-right: 50px;
  margin-top: 30px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  min-height: 36px;
}

img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/Login.vue